import Player from "@vimeo/player";

export default {
  name: "video-player",
  ui: {
    iframe: "[js-video-player-iframe]",
    video: "[js-video-player-video]",
    overlay: "[js-video-player-overlay]",
  },
  events: [
    {
      on: "click",
      target: "overlay",
      handle() {
        this.ui.overlay.classList.add("is-hidden");

        if (this.props.type === "vimeo") {
          this.player.play();
        } else {
          this.ui.video.play();
        }
      },
    },
  ],
  componentDidMount() {
    if (this.props.type === "vimeo") {
      this.player = new Player(this.ui.iframe, {
        id: this.props.id,
        width: 640,
      });
    }
  },
};
